import { parsePhoneNumber } from 'libphonenumber-js';

export { formatPhoneToE164US } from './formatPhoneToE164US';

/**
 * Format a phone number for display in the UI (e.g. (555) 123-4567).
 * Display-only; backend and APIs (Twilio, Spectora) keep E.164.
 */
export function formatPhoneForDisplay(phone: string | undefined | null): string {
  if (!phone || typeof phone !== 'string') return '';
  try {
    const phoneNumber = parsePhoneNumber(phone, 'US');
    return phoneNumber?.formatNational() ?? phone;
  } catch {
    return phone;
  }
}
